// src/components/BCPAdmin.js — BCP管理（タブ切替）
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BcpEmployeeList from './BcpEmployeeList';
import BCPCreateSheet from './BCPCreateSheet';
// 緊急連絡網と同じタブ・ヘッダースタイルを共有
import './OrganizationTree.css';

export default function BCPManager() {
  const navigate = useNavigate();
  // タブ: 'create' = BCP作成 / 'list' = 社員リスト
  const [activeTab, setActiveTab] = useState('create');

  return (
    <div className="ec-page">
      {/* ヘッダー */}
      <div className="ec-header">
        <h2 className="ec-title">BCP管理</h2>
        <div className="ec-header-actions">
          <button className="ec-btn-back" onClick={() => navigate('/dashboard')}>
            戻る
          </button>
        </div>
      </div>

      {/* タブナビゲーション */}
      <div className="ec-tabs">
        <button
          className={`ec-tab${activeTab === 'create' ? ' ec-tab-active' : ''}`}
          onClick={() => setActiveTab('create')}
        >
          BCP作成
        </button>
        <button
          className={`ec-tab${activeTab === 'list' ? ' ec-tab-active' : ''}`}
          onClick={() => setActiveTab('list')}
        >
          社員リスト
        </button>
      </div>

      {/* ===== BCP作成タブ ===== */}
      {activeTab === 'create' && <BCPCreateSheet />}

      {/* ===== 社員リストタブ ===== */}
      {activeTab === 'list' && <BcpEmployeeList />}
    </div>
  );
}
